/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationqueue1Inputs */

const en_moderationqueue1 = /** @type {(inputs: Moderationqueue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderation`)
};

const de_moderationqueue1 = /** @type {(inputs: Moderationqueue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderation`)
};

/**
* | output |
* | --- |
* | "Moderation" |
*
* @param {Moderationqueue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationqueue1 = /** @type {((inputs?: Moderationqueue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationqueue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationqueue1(inputs)
	return de_moderationqueue1(inputs)
});
export { moderationqueue1 as "moderationQueue" }